import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getMedicalConsultSelector } from '../selectors'
import { setAddToTimeLine } from '../store/medicalConsult.actions'
import { MedicalConsultConstants } from '../store/medicalConsult.constants'
import { IMedicalConsultState } from '../store/medicalConsult.types'
import { addMedicalConsultItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveMedicalConsult() {
  const medicalConsultStateWithDefaults: IMedicalConsultState = yield select(getMedicalConsultSelector)
  let medicalConsultState: IMedicalConsultState = {
    ...medicalConsultStateWithDefaults,
    medicalConsultDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    medicalConsultState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: medicalConsultState,
      actionField: (s) => s.method?.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    medicalConsultState = handleNemsisCodeError(error, medicalConsultState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.medicalConsultStateList && pcrDoc.patient?.medicalConsultStateList.length) {
    const index = pcrDoc.patient?.medicalConsultStateList?.findIndex(
      (medicalConsult) => medicalConsult.key === medicalConsultState.key
    )
    if (index !== -1) {
      pcrDoc.patient.medicalConsultStateList[index] = medicalConsultState
    } else {
      pcrDoc.patient?.medicalConsultStateList.push(medicalConsultState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, medicalConsultStateList: [medicalConsultState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addMedicalConsultItem())
  } catch (e) {
    yield put(throwPcrException(`saveMedicalConsult() error: ${e}`))
  }
}

export function* saveMedicalConsultSaga() {
  yield takeLatest(
    [
      MedicalConsultConstants.SAVE_MEDICAL_CONSULT,
      MedicalConsultConstants.SET_DATE,
      MedicalConsultConstants.SET_TIME,
      MedicalConsultConstants.SET_DATE_TIME,
      MedicalConsultConstants.SET_ASSESSED_BY,
      MedicalConsultConstants.SET_ATTEMPTS,
      MedicalConsultConstants.SET_OTHER_PHYSICIAN,
      MedicalConsultConstants.SET_ROLE_PERFORMING,
      MedicalConsultConstants.SET_ROLE_PERFORMING_PNNV,
      MedicalConsultConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      MedicalConsultConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      MedicalConsultConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveMedicalConsult
  )
}
